module.exports = __webpack_public_path__ + "10e819b443883ae6ef37068be13940ce.png";


//////////////////
// WEBPACK FOOTER
// ../assets/screenshots/simone/simone-dashboard.png
// module id = 546
// module chunks = 0